/** Platform app path consts — call sites import these; never inline path strings. */
export const ROUTES = {
   HOME: '/',
   LOGIN: '/login',
   ORGANIZATIONS: '/organizations',
   USERS: '/users',
   SSO: '/sso',
   PLATFORM_SSO: '/platform-sso',
   EMAIL: '/email',
   PLATFORM_EMAIL: '/platform-email',
   PROFILE: '/profile',
   SET_PASSWORD: '/set-password',
   AUTH_POLICY: '/auth-policy'
} as const;
